import clone from 'clone'
import { initialState } from '../index'
import { CLAIMS_INIT_LOADING, CLAIMS_INIT_SUCCESS, CLAIMS_INIT_FAIL, CLAIMS_CLAIMENTRY_INIT_LOADING, CLAIMS_CLAIMENTRY_INIT_SUCCESS, CLAIMS_CLAIMENTRY_INIT_FAIL, CLAIMS_CLAIMDETAIL_RESET, CLAIMS_CLAIMDETAIL_INIT_LOADING, CLAIMS_CLAIMDETAIL_INIT_SUCCESS, CLAIMS_CLAIMDETAIL_INIT_FAIL } from '@/store/types'

export const init = {
  [CLAIMS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CLAIMS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CLAIMS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [CLAIMS_CLAIMENTRY_INIT_LOADING](state) {
    state.claimEntry.init = 0
    state.claimEntry.initErr = []
    state.claimEntry.menu = {}
  },
  [CLAIMS_CLAIMENTRY_INIT_SUCCESS](state, data) {
    state.claimEntry.init = 1
    state.claimEntry.initErr = []
    state.claimEntry.menu = data.menu
  },
  [CLAIMS_CLAIMENTRY_INIT_FAIL](state, error) {
    state.claimEntry.init = 2
    state.claimEntry.initErr = error
    state.claimEntry.menu = {}
  },
  [CLAIMS_CLAIMDETAIL_RESET](state) {
    state.claimDetail = clone(initialState.claimDetail)
  },
  [CLAIMS_CLAIMDETAIL_INIT_LOADING](state) {
    state.claimDetail.init = 0
    state.claimDetail.menu = {}
  },
  [CLAIMS_CLAIMDETAIL_INIT_SUCCESS](state, data) {
    state.claimDetail.init = 1
    state.claimDetail.menu = data.menu
  },
  [CLAIMS_CLAIMDETAIL_INIT_FAIL](state, data) {
    state.claimDetail.init = 2
    state.claimDetail.menu = {}
  }
}
